/**
 * Quick Stats Grid - 4 stat cards showing key metrics
 */

import type { StudentStats } from '@/types/tisa-coins';

interface QuickStatsGridProps {
  stats: StudentStats;
}

export function QuickStatsGrid({ stats }: QuickStatsGridProps) {
  const statCards = [
    {
      icon: '💰',
      label: 'Vault Balance',
      value: stats.vault_balance,
      suffix: 'coins',
      color: 'from-gold to-amber-500',
      sublabel: `€${(stats.vault_balance / 100).toFixed(2)}`
    },
    {
      icon: '✨',
      label: 'Total XP',
      value: stats.total_xp,
      suffix: 'XP',
      color: 'from-emerald to-teal-500'
    },
    {
      icon: '🏆',
      label: 'Badges Earned',
      value: stats.badges_earned,
      suffix: 'badges',
      color: 'from-purple to-pink-500'
    },
    {
      icon: '📋',
      label: 'Quests Complete',
      value: stats.quests_completed,
      suffix: 'quests',
      color: 'from-blue-500 to-cyan-500',
      sublabel: `${stats.quests_active} active`
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards.map((card, index) => (
        <div
          key={index}
          className="bg-gradient-to-br from-gray-900/50 to-gray-800/50 border-2 border-gray-700/50 rounded-xl p-6 hover:border-gold/50 transition-all duration-300 hover:scale-105"
        >
          <div className="flex items-center justify-between mb-3">
            <span className="text-4xl">{card.icon}</span>
            <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${card.color} opacity-20`}></div>
          </div>
          <p className="text-gray-400 text-sm font-poppins mb-1">{card.label}</p>
          <p className="text-3xl font-orbitron font-black text-white mb-1">
            {card.value}
          </p>
          <p className="text-xs text-gray-500">{card.sublabel || card.suffix}</p>
        </div>
      ))}
    </div>
  );
}
